export function toCssClassName(source: string, delimiter = '_') {
    return source.split(/(?=[A-Z])/)
        .join(delimiter)
        .replace(new RegExp(delimiter + "{2,}"), delimiter)
        .toLowerCase();
}